import { Component, inject, Input } from '@angular/core';
import { LoaderComponent } from '../../../Component/Loader/loader/loader.component';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ExpenseService } from '../../../Model/Expense/expense.service';
import { CommonService } from '../../../Model/Common/common.service';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { TooltipService } from '../../../Util/Tooltip/tooltip.service';
import { AlertSuccessComponent } from '../../../Component/Alert/alert-success/alert-success.component';
import { AlertWarningComponent } from '../../../Component/Alert/alert-warning/alert-warning.component';
import { ConfirmationComponent } from '../../../Component/Confirmation/confirmation/confirmation.component';

@Component({
  selector: 'app-expense-category-form',
  standalone: true,
  imports: [FormsModule, CommonModule, LoaderComponent],
  templateUrl: './expense-category-form.component.html',
  styleUrl: './expense-category-form.component.scss'
})
export class ExpenseCategoryFormComponent {
  isDisabled: boolean = false;
  activeModal = inject(NgbActiveModal);
  @Input() ID!: number;

  ExpenseCategory = {
    SelectType: 'insert',
    ESS_ExpenseCategoryMasterId: 0,
    ExpenseCategoryName: null,
    //ClassName: null,
    AccountGLCode: null,
    IsLocal: false,
    IsOutStation: false,
    IsActive: true,
  }

  constructor(
    private toast: ToastService,
    private expense: ExpenseService,
    private modalService: NgbModal,
    protected common: CommonService,
    private tooltip : TooltipService
  ) {
    this.common.getPageRights();
  }

  ngOnInit(): void {
    this.ExpenseCategory.ESS_ExpenseCategoryMasterId = this.ID;
    if(this.ExpenseCategory.ESS_ExpenseCategoryMasterId == undefined){
      this.ExpenseCategory.ESS_ExpenseCategoryMasterId = 0;
    }
    if (this.ID > 0) {
      this.ESS_ExpenseCategoryMasterSelect();
    }
  }

  Validate(form: any) {
    if (form.valid) {
      if(this.ExpenseCategory.IsLocal || this.ExpenseCategory.IsOutStation){
        this.ESS_ExpenseCategoryMaster_InsertUpdate();
      }else{
        this.toast.show({message:'Please select Local or OutStation or both',type:toastTypeEnum.warning});
      }
    }
    else {
      form.submitted = true;
    }
  }

  ESS_ExpenseCategoryMasterSelect() {
    this.isDisabled = true;
    this.expense.ESS_ExpenseCategoryMasterSelect({ ESS_ExpenseCategoryMasterId: this.ExpenseCategory.ESS_ExpenseCategoryMasterId, SelectType: 1 }).subscribe({
      next: (response) => {
        this.ExpenseCategory = response.Table[0];
        //this.ExpenseCategory.ClassName = response.Table1.map((e:any) => e.ClassName).toString();
        this.ExpenseCategory.SelectType = 'update';
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  async ESS_ExpenseCategoryMaster_InsertUpdate() {
    //await this.common.getPageRights();
    const modalRef = this.modalService.open(ConfirmationComponent);
    modalRef.componentInstance.Message = 'Do you want to save?';
    modalRef.result.then((result) => {
      if((this.ExpenseCategory.ESS_ExpenseCategoryMasterId == 0 && this.common.PageRight.IsAdd) || (this.ExpenseCategory.ESS_ExpenseCategoryMasterId > 0 && this.common.PageRight.IsEdit)){
        if (result) {
          this.isDisabled = true;
          this.expense.ESS_ExpenseCategoryMaster_InsertUpdate(this.ExpenseCategory).subscribe({
            next: (response) => {
              if (response.Error_Code == '421' || response.Error_Code == '422') {
                const modalRef = this.modalService.open(AlertSuccessComponent, {
                  size: 'md',
                  backdrop: 'static',
                  centered: true,
                  windowClass: 'confirmation-modal'
                });
                modalRef.componentInstance.Message = response.Error_Message;
                modalRef.result.then((result: any) => {
                  if (result) {
                    this.activeModal.close();
                  }
                });
              }
              else {
                const modalRef = this.modalService.open(AlertWarningComponent, {
                  size: 'md',
                  backdrop: 'static',
                  centered: true,
                  windowClass: 'confirmation-modal'
                });
                modalRef.componentInstance.Message = response.Error_Message;
                modalRef.result.then((result: any) => { });
              }
              console.log(response.Error_Message);
              this.isDisabled = false;
            },
            complete: () => { },
            error: (error) => {
              this.isDisabled = false;
            },
          });
        }
      }else{
        this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
      }
    });
  }

  close() {
    this.activeModal.close();
  }
}
